exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tab {\r\n  padding: 0.5rem 1rem;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  border-bottom: 3px solid transparent;\r\n  transition: border-color 0.4s cubic-bezier();\r\n}\r\n.tab:hover {\r\n  background: #efefef;\r\n}\r\n.tab.active {\r\n  border-color: steelblue;\r\n  background: #fafafa;\r\n}\r\n.tab h2 {\r\n  padding: 0;\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  text-transform: uppercase;\r\n}", ""]);

// exports
